module.exports = __webpack_public_path__ + "img/roboto-v20-latin-100.bdd892cd.svg";